
import { OTP_API } from "../config/api";

class OtpService {

    // Generate OTP Code ====================================================================================================

    /**
     * Generate OTP Code
     * @type {object}
     * @property {string} destinationMail
     * @returns {object} - True or false if the OTP Code was sent
    */
    generateTheOtpCode(data) {
        const url = `/send-otp`;

        return OTP_API.post(url, data);
    }


    // Validate OTP Code ====================================================================================================

    /**
     * Validate OTP Code
     * @type {object}
     * @property {string} token
     * @property {string} destinationMail
     * @returns {object} - True or false if the OTP Code was validated
    */
    validateTheOtpCode(data) {
        const url = `/validate-opt`;

        return OTP_API.post(url, data);
    }

}

export default new OtpService();